/**
 * The DOM event names components listen for. Prefixed with `ON_` so the vocabulary never collides
 * with the tag names, which spell some of the same words.
 */
export type DomEventName = keyof HTMLElementEventMap;
export type WindowEventName = keyof WindowEventMap;

export const ON_BLUR = "blur" satisfies DomEventName;
export const ON_CHANGE = "change" satisfies DomEventName;
export const ON_CLICK = "click" satisfies DomEventName;
export const ON_FOCUS = "focus" satisfies DomEventName;
export const ON_INPUT = "input" satisfies DomEventName;
export const ON_KEY_DOWN = "keydown" satisfies DomEventName;
export const ON_SUBMIT = "submit" satisfies DomEventName;

export const ON_POP_STATE = "popstate" satisfies WindowEventName;
